<template>
 <!--

    Shows notify alerts as a snackbar upon request, top right

    Usage:
      this.$notify (message, type, options)

    message: the text to display, default is 'Error'
    type: determines snackbar color to use, one of these
      error = default = red
      warning = orange
      success = green
      info = blue
    options:
      stay: a boolean, whether snackbar shall stay (or leave after default timeout)
      long: a boolean, use the longer timeout
      icon: string, prepended icon

    Examples
      this.$notify(
        'A fake error occured!'
      )
      this.$notify(
        'Only a short temporary snack!', 'success'
      )
      this.$notify(
        'This is a persistent info to click off!', 'info', {stay: true})
      )

  -->
  <div class="text-right">
    <v-snackbar v-for="(m, i) in this.$root.notify"
      :key="i"
      v-model="m.on"
      :color="color(m.type)"
      :top="Boolean(1)"
      :right="Boolean(1)"
      :absolute="true"
      :style="hpos(i)"
      :timeout="m.timeout"
    >
      <div class="d-flex">
        <v-icon v-if="m.icon" left>{{m.icon}}</v-icon>
        <p class="ma-0">{{ m.message }}</p>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          icon
          v-bind="attrs"
          @click="m.on = false"
        >
          <!--{{ $t('close') }}-->
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
const DEFAULT_TIMEOUT = 3000
const LONG_TIMEOUT = 6000

export default {
  name: 'MessageSnackbar',
  components: {},
  methods: {
    open (message, type, options) {
      let timeout = DEFAULT_TIMEOUT

      if (options?.stay) {
        timeout = -1
      } else if (options?.long) {
        timeout = LONG_TIMEOUT
      }
      this.$root.notify.push(
        {
          on: true,
          message: message || 'Error',
          type: type || 'error',
          timeout,
          icon: options?.icon || null
        }
      )
    },
    hpos (i) {
      return 'margin-top: '.concat(i * 60, 'px')
    },
    color (t) {
      if (t === 'success') return 'success'
      if (t === 'warning') return 'warning'
      if (t === 'info') return 'info'
      return 'error'
    },
    resetQueue () {
      for (let i = 0; i < this.$root.notify.length; i++) {
        if (this.$root.notify[i].on === false) {
          this.$root.notify.splice(i, 1)
        }
      }
    }
  },
  computed: {
  },
  updated () {
    this.resetQueue()
  }
}
</script>
